document.addEventListener('DOMContentLoaded', function () {
  var selectors = {
    mediaWrapper: '.grid__item.product__media-wrapper',
    submitButton: '.product-form__submit',
    productFormButtons: '.product-form__buttons',
    addonInput: '.product-addon-card__input',
    variantInput: '.product-variant-id',
    quantityInput: '.new-quantity-input-wp',
    spinner: '.product-form__buttons .loading__spinner',
    productFormErrorWrapper: '.product-form__error-message-wrapper',
    productFormErrorMessage: '.product-form__error-message',
    cartDrawer: '.cart-drawer-outer',
    cartDrawerElement: 'cart-drawer',
    cartIcon: '.header__icon--cart',
    techBuyLink: '.tech-btn-outer a, .tech-btn-outer-2 a'
  };

  var mediaWrapper = document.querySelector(selectors.mediaWrapper);
  var submitButton = document.querySelector(selectors.submitButton);
  var productFormButtons = document.querySelector(selectors.productFormButtons);
  var addonInputs = Array.from(document.querySelectorAll(selectors.addonInput));
  var hld86PurchaseActions = document.querySelector('[data-hld-86-buy-label]');
  var hld86ProductInfo = hld86PurchaseActions && hld86PurchaseActions.closest('product-info');
  var hld86PriceContainer = hld86ProductInfo && hld86ProductInfo.querySelector('[id^="price-"]');
  var hld86QuantityInput = hld86ProductInfo && hld86ProductInfo.querySelector('.quantity__input');

  function getHld86DisplayedPrice() {
    var price = hld86PriceContainer && hld86PriceContainer.querySelector('.price');

    if (!hld86PriceContainer || hld86PriceContainer.classList.contains('hidden') || !price) {
      return '';
    }

    var priceElement = price.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--sale')
      : price.querySelector('.price__regular .price-item--regular:not(.variant-item__old-price)');

    return priceElement ? priceElement.textContent.trim() : '';
  }

  function enforceHld86BuyLabel() {
    if (!hld86PurchaseActions) {
      return;
    }

    var buyButtons = Array.from(
      hld86PurchaseActions.querySelectorAll('.hld-86-purchase-actions__buy [id^="ProductSubmitButton-"]')
    );
    var nativeStateButton = buyButtons.find(function (button) {
      var label = button.querySelector('.hld-86-native-buy-label');
      var text = label ? label.textContent.trim() : '';

      return button.disabled && (text === window.variantStrings.soldOut || text === window.variantStrings.unavailable);
    });

    if (buyButtons.length === 0) {
      return;
    }

    var buyPrefix = hld86PurchaseActions.getAttribute('data-hld-86-buy-prefix');
    var displayedPrice = getHld86DisplayedPrice();
    var expectedLabel;

    if (nativeStateButton) {
      expectedLabel = nativeStateButton.querySelector('.hld-86-native-buy-label').textContent.trim();
    } else if (displayedPrice) {
      expectedLabel = buyPrefix + ' ' + displayedPrice;
    } else {
      expectedLabel = hld86PurchaseActions.getAttribute('data-hld-86-buy-label');
    }

    buyButtons.forEach(function (buyButton) {
      var nativeButtonLabel = buyButton.querySelector('.hld-86-native-buy-label');

      if (buyButton.getAttribute('aria-label') !== expectedLabel) {
        buyButton.setAttribute('aria-label', expectedLabel);
      }

      if (nativeButtonLabel && nativeButtonLabel.textContent.trim() !== expectedLabel) {
        nativeButtonLabel.textContent = expectedLabel;
      }
    });

  }

  function hideHld86PreorderBadges() {
    if (!hld86PriceContainer) {
      return;
    }

    hld86PriceContainer.querySelectorAll('*').forEach(function (element) {
      var text = element.textContent.trim().toLowerCase();

      if (element.children.length === 0 && (text === 'pre-order' || text === 'preorder')) {
        element.hidden = true;
        element.setAttribute('aria-hidden', 'true');
        element.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function maintainHld86PurchaseLabels() {
    enforceHld86BuyLabel();
    hideHld86PreorderBadges();
  }

  stripTrailingZeroPrices(document);

  if (hld86PurchaseActions) {
    maintainHld86PurchaseLabels();

    var hld86ButtonObserver = new MutationObserver(maintainHld86PurchaseLabels);
    hld86ButtonObserver.observe(hld86PurchaseActions, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });

    if (hld86PriceContainer) {
      var hld86PriceObserver = new MutationObserver(maintainHld86PurchaseLabels);
      hld86PriceObserver.observe(hld86PriceContainer, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (hld86QuantityInput && typeof hld86ProductInfo.setQuantityBoundries === 'function') {
      var hld86QuantityObserver = new MutationObserver(function () {
        hld86ProductInfo.setQuantityBoundries();
      });
      hld86QuantityObserver.observe(hld86QuantityInput, {
        attributes: true,
        attributeFilter: ['data-cart-quantity', 'data-min', 'data-max', 'step']
      });
    }
  }

  function stripTrailingZeroPrices(scope) {
    var pricePattern = /((?:US)?\$\s?\d[\d,]*)\.00\b/g;
    var priceNodes = (scope || document).querySelectorAll(
      '.price, .price-item, .product-option, .cart-item__price-wrapper, [class*="price"]'
    );

    priceNodes.forEach(function (node) {
      node.childNodes.forEach(function (child) {
        if (child.nodeType === Node.TEXT_NODE) {
          var cleanText = child.textContent.replace(pricePattern, '$1');

          if (cleanText !== child.textContent) {
            child.textContent = cleanText;
          }
        }
      });
    });
  }

  function suppressLegacyOptionApps() {
    if (addonInputs.length === 0) {
      return;
    }

    document
      .querySelectorAll('[id*="globo_product_options"], .gpo-container, .gpo-app, .gpo-form')
      .forEach(function (element) {
        var appBlock = element.closest('[id^="shopify-block-"]') || element;

        appBlock.setAttribute('hidden', 'hidden');
        appBlock.style.display = 'none';
      });
  }

  function setLoading(isLoading) {
    var spinner = document.querySelector(selectors.spinner);

    if (spinner) {
      spinner.classList.toggle('hidden', !isLoading);
    }

    if (productFormButtons) {
      productFormButtons.classList.toggle('button-hide', isLoading);
    }

    if (submitButton) {
      submitButton.classList.toggle('loading', isLoading);

      if (isLoading) {
        submitButton.setAttribute('aria-busy', 'true');
      } else {
        submitButton.removeAttribute('aria-busy');
      }
    }
  }

  function formatCartError(errorData) {
    var errorMessage = errorData && (errorData.description || errorData.message || errorData.errors);

    if (!errorMessage) {
      if (errorData && errorData.responseText) {
        var responseText = errorData.responseText.replace(/\s+/g, ' ').trim();

        if (responseText && !isHtmlErrorResponse(responseText, errorData.contentType)) {
          return responseText;
        }
      }

      if (errorData && errorData.status) {
        return 'Cart add failed with HTTP ' + errorData.status + '. Please try again.';
      }

      return 'There was a problem adding these products to your cart. Please try again.';
    }

    if (Array.isArray(errorMessage)) {
      return errorMessage.join(' ');
    }

    if (typeof errorMessage === 'object') {
      return Object.keys(errorMessage)
        .map(function (key) {
          var value = errorMessage[key];

          return Array.isArray(value) ? value.join(' ') : value;
        })
        .filter(Boolean)
        .join(' ');
    }

    return String(errorMessage);
  }

  function isHtmlErrorResponse(responseText, contentType) {
    var normalizedContentType = String(contentType || '').toLowerCase();
    var normalizedText = String(responseText || '').trim().toLowerCase();

    return normalizedContentType.indexOf('text/html') > -1 ||
      normalizedText.indexOf('<!doctype html') === 0 ||
      normalizedText.indexOf('<html') === 0 ||
      normalizedText.indexOf('<body') > -1;
  }

  function showCartError(message) {
    var errorWrapper = document.querySelector(selectors.productFormErrorWrapper);
    var errorMessage = errorWrapper && errorWrapper.querySelector(selectors.productFormErrorMessage);

    if (!errorWrapper || !errorMessage) {
      return;
    }

    errorWrapper.toggleAttribute('hidden', !message);
    errorMessage.textContent = message || '';
  }

  function parseCartAddResponse(response) {
    return response.text()
      .then(function (text) {
        var body = {};

        if (text) {
          try {
            body = JSON.parse(text);
          } catch (error) {
            body = {
              responseText: text,
              status: response.status,
              contentType: response.headers.get('content-type') || ''
            };
          }
        }

        if (!response.ok || body.status) {
          var cartError = new Error(formatCartError(body) || ('Cart add failed with HTTP ' + response.status + '.'));
          cartError.status = body.status || response.status;
          throw cartError;
        }

        return body;
      });
  }

  function postCartItems(cartAddUrl, items) {
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      return parseCartAddResponse(response);
    });
  }

  function getCartJsonUrl() {
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
    return cartUrl.replace(/\/$/, '') + '.js';
  }

  function getCartAddJsonUrl() {
    var cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';
    return cartAddUrl.indexOf('.js') > -1 ? cartAddUrl : cartAddUrl.replace(/\/$/, '') + '.js';
  }

  function getCartVariantQuantities() {
    return fetch(getCartJsonUrl(), {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart fetch failed with HTTP ' + response.status + '.');
        }

        return response.json();
      })
      .then(function (cart) {
        var quantities = {};

        (cart.items || []).forEach(function (item) {
          quantities[String(item.variant_id)] = (quantities[String(item.variant_id)] || 0) + Number(item.quantity || 0);
        });

        return quantities;
      });
  }

  function getRequestedItemQuantities(items) {
    var quantities = {};

    items.forEach(function (item) {
      quantities[String(item.id)] = (quantities[String(item.id)] || 0) + Number(item.quantity || 1);
    });

    return quantities;
  }

  function getMissingCartItems(items, requestedQuantities, beforeQuantities, afterQuantities) {
    var missingItems = [];
    var handledIds = {};

    items.forEach(function (item) {
      var id = String(item.id);

      if (handledIds[id]) {
        return;
      }

      handledIds[id] = true;
      var targetQuantity = (beforeQuantities[id] || 0) + requestedQuantities[id];
      var currentQuantity = afterQuantities[id] || 0;

      if (currentQuantity < targetQuantity) {
        missingItems.push(Object.assign({}, item, {
          quantity: targetQuantity - currentQuantity
        }));
      }
    });

    return missingItems;
  }

  function addItemsToCart(cartAddUrl, items) {
    var beforeCartPromise = items.length > 1 ? getCartVariantQuantities().catch(function () {
      return null;
    }) : Promise.resolve(null);

    return beforeCartPromise.then(function (beforeQuantities) {
      return postCartItems(cartAddUrl, items)
        .catch(function (error) {
          if (!beforeQuantities || items.length < 2 || !error.status || error.status < 500) {
            throw error;
          }

          var requestedQuantities = getRequestedItemQuantities(items);

          return getCartVariantQuantities()
            .then(function (afterQuantities) {
              var missingItems = getMissingCartItems(items, requestedQuantities, beforeQuantities, afterQuantities);

              if (!missingItems.length) {
                return { recovered: true };
              }

              return postCartItems(cartAddUrl, missingItems);
            })
            .catch(function () {
              throw error;
            });
        });
      });
  }

  function getSelectedItems() {
    var variantInput = document.querySelector(selectors.variantInput);
    var quantityInput = document.querySelector(selectors.quantityInput);

    if (!variantInput) {
      return [];
    }

    var items = [
      {
        id: variantInput.value,
        quantity: quantityInput ? Number(quantityInput.value || 1) : 1
      }
    ];

    addonInputs.forEach(function (input) {
      if (input.checked && !input.disabled) {
        items.push({
          id: input.value,
          quantity: 1
        });
      }
    });

    return items;
  }

  function refreshCartDrawer(activeElement) {
    var cartUrl = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';

    return fetch(cartUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (cartData) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(cartData, 'text/html');
        var cartDrawer = doc.querySelector(selectors.cartDrawer);
        var cartCountIcon = doc.querySelector(selectors.cartIcon);
        var currentCartDrawer = document.querySelector(selectors.cartDrawer);
        var currentCartCountIcon = document.querySelector(selectors.cartIcon);

        if (cartDrawer && currentCartDrawer) {
          var sourceDrawer = cartDrawer.querySelector(selectors.cartDrawerElement);
          var drawer = currentCartDrawer.querySelector(selectors.cartDrawerElement);

          if (sourceDrawer && drawer) {
            drawer.className = sourceDrawer.className;
            drawer.innerHTML = sourceDrawer.innerHTML;

            var overlay = drawer.querySelector('#CartDrawer-Overlay');

            if (overlay && typeof drawer.close === 'function') {
              overlay.addEventListener('click', drawer.close.bind(drawer));
            }

            if (typeof drawer.open === 'function') {
              drawer.open(activeElement);
            } else {
              drawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }
          } else {
            currentCartDrawer.innerHTML = cartDrawer.innerHTML;
          }
        }

        if (cartCountIcon && currentCartCountIcon) {
          currentCartCountIcon.innerHTML = cartCountIcon.innerHTML;
        }

        stripTrailingZeroPrices(currentCartDrawer || document);
      });
  }

  var priceFormatQueued = false;
  var priceObserver = new MutationObserver(function () {
    if (priceFormatQueued) {
      return;
    }

    priceFormatQueued = true;
    window.requestAnimationFrame(function () {
      stripTrailingZeroPrices(document);
      priceFormatQueued = false;
    });
  });

  priceObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  if (addonInputs.length > 0) {
    suppressLegacyOptionApps();

    var legacyOptionObserver = new MutationObserver(suppressLegacyOptionApps);
    legacyOptionObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var cartVariantIds = cart.items.map(function (item) {
          return String(item.variant_id);
        });

        addonInputs.forEach(function (input) {
          var alreadyInCart = cartVariantIds.includes(input.value);

          if (alreadyInCart) {
            input.checked = false;
            input.disabled = true;
            input.closest('.product-addon-card').classList.add('is-in-cart');
          }
        });
      })
      .catch(function (error) {
        console.error('Error checking add-ons in cart:', error);
      });
  }

  if (submitButton && mediaWrapper && addonInputs.length > 0) {
    submitButton.addEventListener('click', function (e) {
      if (submitButton.disabled) {
        return;
      }

      e.preventDefault();

      showCartError('');

      var items = getSelectedItems();

      if (items.length === 0) {
        return;
      }

      setLoading(true);

      var cartDrawer = document.querySelector(selectors.cartDrawerElement);
      var activeElement = document.activeElement;
      var cartAddUrl = getCartAddJsonUrl();

      if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(activeElement);
      }

      addItemsToCart(cartAddUrl, items)
        .then(function () {
          return refreshCartDrawer(activeElement);
        })
        .catch(function (error) {
          showCartError(error.message);
          console.error('Error adding products to cart:', error);
        })
        .finally(function () {
          setLoading(false);
        });
    });
  }

  document.querySelectorAll(selectors.techBuyLink).forEach(function (link) {
    link.addEventListener('click', function (e) {
      var productFormButton = document.querySelector(selectors.submitButton);

      if (productFormButton) {
        e.preventDefault();
        productFormButton.click();
      }
    });
  });
});
